import React from 'react';
import PropTypes from 'prop-types';
import { Select, Radio, Button, Row, Col, Input } from 'antd';
const { Option } = Select;

const typeOptions = ['google', 'custom'];
const formatOptions = ['ttf', 'woff', 'woff2', 'css'];

const CreateFont = ({ font, onClick, onChange, onSelectChange }) => {
  return (
    <div className="">
      <Row className="margin-bottom-10">
        <Col span={3}>
          <span>Name:</span>
        </Col>
        <Col span={21} className="margin-bottom-10">
          <Input
            name="name"
            placeholder={`Enter font name here`}
            className="ant-input"
            value={font.name}
            onChange={onChange}
          />
        </Col>
        <Col span={3}>
          <span>Type:</span>
        </Col>
        <Col span={21} className="margin-bottom-10">
          <Radio.Group name="type" value={font.type} onChange={onChange}>
            {typeOptions
              ? typeOptions.map((option, i) => (
                  <Radio key={i} value={option}>
                    {option}
                  </Radio>
                ))
              : null}
          </Radio.Group>
        </Col>
        <Col span={3}>
          <span>Format:</span>
        </Col>
        <Col span={21} className="margin-bottom-10">
          <Select
            placeholder="Please select courier partner"
            value={font.format}
            mode="single"
            style={{ width: '100%' }}
            onChange={value => onSelectChange(value)}
            filterOption={(input, option) =>
              option.props.children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
            }
          >
            {formatOptions
              ? formatOptions.map((option, i) => (
                  <Option key={i} value={option}>
                    {option}
                  </Option>
                ))
              : null}
          </Select>
        </Col>
        <Col span={3}>
          <span>Family:</span>
        </Col>
        <Col span={21} className="margin-bottom-10">
          <Input
            name="family"
            placeholder={`Enter font family here`}
            className="ant-input"
            value={font.family}
            onChange={onChange}
          />
        </Col>
        <Col span={3}>
          <span>URL:</span>
        </Col>
        <Col span={21} className="margin-bottom-10">
          <Input
            name="URL"
            placeholder={`Enter font URL here`}
            className="ant-input"
            value={font.URL}
            onChange={onChange}
          />
        </Col>
        <Col span={24} className="margin-bottom-20">
          <Button type="primary" onClick={onClick}>
            Submit
          </Button>
        </Col>
      </Row>
    </div>
  );
};

CreateFont.propTypes = {
  font: PropTypes.object,
  onClick: PropTypes.func,
  onChange: PropTypes.func,
  onSelectChange: PropTypes.func,
  typeOptions: PropTypes.array,
  formatOptions: PropTypes.array
};

export default CreateFont;
